/* Тема оформления: авто (как в Telegram) · светлая · тёмная.
   Выбор запоминается, поэтому вернуться на светлую можно в любой момент. */

const KEY = "mera.theme";
export const THEMES = [
  { id: "auto", label: "Авто" },
  { id: "light", label: "Светлая" },
  { id: "dark", label: "Тёмная" },
];

const listeners = new Set();

export const getThemePref = () => localStorage.getItem(KEY) || "auto";

const systemScheme = () =>
  window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";

/** Схема, которую диктует окружение: внутри Telegram — его тема, снаружи — системная */
function envScheme() {
  const tg = window.Telegram?.WebApp;
  if (tg?.initData) return tg.colorScheme === "dark" ? "dark" : "light";
  return systemScheme();
}

/** Итоговая схема с учётом выбора участника */
export function resolvedScheme() {
  const pref = getThemePref();
  return pref === "auto" ? envScheme() : pref;
}

/* Своя палитра для ручного выбора.

   Цвета интерфейса собраны из themeParams Telegram, а он кладёт их инлайном
   на <html> под свою тему. Пока выбор «Авто», это ровно то, что нужно. Но стоит
   выбрать тему руками — значения остаются от темы Telegram, и классу `dark`
   нечего красить: экран не меняется. Поэтому на ручном выборе кладём поверх
   свои значения — тем же инлайном, он сильнее правил из таблицы стилей. */
const PALETTE = {
  light: {
    "--tg-bg": "#ffffff",
    "--tg-secondary-bg": "#f2f2f7",
    "--tg-section-bg": "#ffffff",
    "--tg-text": "#000000",
    "--tg-hint": "#8e8e93",
    "--tg-subtitle": "#8e8e93",
    "--tg-section-header": "#6d6d72",
    "--tg-link": "#007aff",
    "--tg-accent": "#007aff",
    "--tg-button": "#007aff",
    "--tg-button-text": "#ffffff",
    "--tg-destructive": "#ff3b30",
  },
  dark: {
    "--tg-bg": "#17212b",
    "--tg-secondary-bg": "#0e1621",
    "--tg-section-bg": "#17212b",
    "--tg-text": "#f5f5f5",
    "--tg-hint": "#7d8b99",
    "--tg-subtitle": "#7d8b99",
    "--tg-section-header": "#7d8b99",
    "--tg-link": "#0a84ff",
    "--tg-accent": "#0a84ff",
    "--tg-button": "#0a84ff",
    "--tg-button-text": "#ffffff",
    "--tg-destructive": "#ff453a",
  },
};

const VARS = Object.keys(PALETTE.light);

/** Ручной выбор рисуем своей палитрой, «Авто» — возвращаем цвета Telegram */
function paint(scheme, manual) {
  const root = document.documentElement.style;
  for (const key of VARS) {
    if (manual) root.setProperty(key, PALETTE[scheme][key]);
    else root.removeProperty(key);
  }
}

/** Применяет тему к документу */
export function applyTheme() {
  const pref = getThemePref();
  const scheme = pref === "auto" ? envScheme() : pref;
  const dark = scheme === "dark";
  paint(scheme, pref !== "auto");
  document.documentElement.classList.toggle("dark", dark);
  document.documentElement.style.colorScheme = dark ? "dark" : "light";

  // Красим шапку Telegram под фон приложения
  const tg = window.Telegram?.WebApp;
  if (tg?.initData) {
    const bg = getComputedStyle(document.documentElement).getPropertyValue("--tg-secondary-bg").trim();
    if (/^#[0-9a-f]{6}$/i.test(bg)) tg.setHeaderColor?.(bg);
    else tg.setHeaderColor?.("secondary_bg_color");
  }

  listeners.forEach((fn) => fn(scheme));
  return scheme;
}

export function setThemePref(pref) {
  if (pref === "auto") localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, pref);
  return applyTheme();
}

/** Подписка на смену темы — для компонентов, которые показывают её состояние */
export function onThemeChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Следим за источниками «авто»: системная тема и тема Telegram */
export function watchEnvTheme() {
  const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
  const onEnv = () => {
    if (getThemePref() === "auto") applyTheme();
  };
  mq?.addEventListener?.("change", onEnv);
  window.Telegram?.WebApp?.onEvent?.("themeChanged", onEnv);
  return () => mq?.removeEventListener?.("change", onEnv);
}
